<template>
    <div></div>
</template>
<script>
import { API } from "@/api.js";
export default {
	name: "Tickets",
	data() {
		return {
			filter: "",
			dismissCountDown: 0,
			dismissSecs: 5,
			form: {
				company: null,
				contPers: null,
				machine: null,
				subject: null,
				tipoInt: null,
				classProb: null,
				description: null,
			},
			file: null,
			openticket: false,
			fields: [
				{ key: "code", sortable: true, class:"font-weight-bold", },
				{ key: "title", sortable: true, },
				{ key: "type", sortable: true, },
				{ key: "opendate", sortable: true, formatter: "dateFormatter", },
				{ key: "closedate", sortable: true, formatter: "dateFormatter", },
			],
			tickets: [ ],
			machines: [ ],
		};
	},
	components: {},
	computed: {
		tipoInts(){
			return ["","Tipo 1","Tipo 2"]
		},
		classProbs(){
			return ["","Problem 1","Problem 2"]
		},
	},
	async mounted() {
		let tickets = await API.lastTickets(99999)
		this.tickets = tickets.map(t => ({...t, opendate: new Date(t.opendate), closedate: new Date(t.closedate)}))
		this.machines = (await API.getUnits(false,'servicecare')).map(u => u.code + " - " + u.name)
		this.machines.unshift({id:0, text:""})
	},
	methods: {
		async openTicket(){
			this.openticket = true
			for(let fld in this.form){
				this.form[fld] = null
			}
			this.form.company = await API.getClientName()
			this.form.contPers = this.$store.getters.name + " " + this.$store.getters.surname
		},
		countDownChanged(dismissCountDown) {
			this.dismissCountDown = dismissCountDown
		},
		showAlert() {
			this.dismissCountDown = this.dismissSecs
		},
		dateFormatter(value){
			return value.toLocaleDateString()
		},
		async onSubmit(){
			console.log("onSubmit",this.file)
			const formData = new FormData()
			formData.append('data', JSON.stringify(this.form))
			formData.append('upload', this.file)
			await API.sendTicket(formData)
			this.openticket = false
			this.showAlert()
		},
		onReset(){
			console.log("onSubmit")
		},
	},
};
</script>
<style>
	div.tickets td , div.tickets th{
		text-align: left;
	}
    div.tickets div.mb-0 {
        margin-top: 10px !important;
        margin-bottom: 10px !important;
    }
</style>
